/**
 * MATLAB Language Types
 * Token types and AST nodes specific to MATLAB syntax
 */
export var MatlabTokenType;
(function (MatlabTokenType) {
    // Literals
    MatlabTokenType["NUMBER"] = "NUMBER";
    MatlabTokenType["IDENTIFIER"] = "IDENTIFIER";
    MatlabTokenType["STRING"] = "STRING";
    // Operators
    MatlabTokenType["PLUS"] = "PLUS";
    MatlabTokenType["MINUS"] = "MINUS";
    MatlabTokenType["MULTIPLY"] = "MULTIPLY";
    MatlabTokenType["DIVIDE"] = "DIVIDE";
    MatlabTokenType["POWER"] = "POWER";
    MatlabTokenType["BACKSLASH"] = "BACKSLASH";
    // Element-wise operators
    MatlabTokenType["DOT_MULTIPLY"] = "DOT_MULTIPLY";
    MatlabTokenType["DOT_DIVIDE"] = "DOT_DIVIDE";
    MatlabTokenType["DOT_POWER"] = "DOT_POWER";
    MatlabTokenType["DOT_BACKSLASH"] = "DOT_BACKSLASH";
    // Comparison
    MatlabTokenType["EQ"] = "EQ";
    MatlabTokenType["NE"] = "NE";
    MatlabTokenType["LT"] = "LT";
    MatlabTokenType["LE"] = "LE";
    MatlabTokenType["GT"] = "GT";
    MatlabTokenType["GE"] = "GE";
    // Logical
    MatlabTokenType["AND"] = "AND";
    MatlabTokenType["OR"] = "OR";
    MatlabTokenType["SHORT_AND"] = "SHORT_AND";
    MatlabTokenType["SHORT_OR"] = "SHORT_OR";
    MatlabTokenType["NOT"] = "NOT";
    // Assignment
    MatlabTokenType["ASSIGN"] = "ASSIGN";
    // Delimiters
    MatlabTokenType["LPAREN"] = "LPAREN";
    MatlabTokenType["RPAREN"] = "RPAREN";
    MatlabTokenType["LBRACKET"] = "LBRACKET";
    MatlabTokenType["RBRACKET"] = "RBRACKET";
    MatlabTokenType["LBRACE"] = "LBRACE";
    MatlabTokenType["RBRACE"] = "RBRACE";
    MatlabTokenType["COMMA"] = "COMMA";
    MatlabTokenType["COLON"] = "COLON";
    MatlabTokenType["SEMICOLON"] = "SEMICOLON";
    MatlabTokenType["TRANSPOSE"] = "TRANSPOSE";
    MatlabTokenType["CTRANSPOSE"] = "CTRANSPOSE";
    MatlabTokenType["AT"] = "AT";
    MatlabTokenType["DOT"] = "DOT";
    // Keywords
    MatlabTokenType["FUNCTION"] = "FUNCTION";
    MatlabTokenType["END"] = "END";
    MatlabTokenType["IF"] = "IF";
    MatlabTokenType["ELSEIF"] = "ELSEIF";
    MatlabTokenType["ELSE"] = "ELSE";
    MatlabTokenType["FOR"] = "FOR";
    MatlabTokenType["WHILE"] = "WHILE";
    MatlabTokenType["SWITCH"] = "SWITCH";
    MatlabTokenType["CASE"] = "CASE";
    MatlabTokenType["OTHERWISE"] = "OTHERWISE";
    MatlabTokenType["TRY"] = "TRY";
    MatlabTokenType["CATCH"] = "CATCH";
    MatlabTokenType["RETURN"] = "RETURN";
    MatlabTokenType["BREAK"] = "BREAK";
    MatlabTokenType["CONTINUE"] = "CONTINUE";
    MatlabTokenType["GLOBAL"] = "GLOBAL";
    MatlabTokenType["PERSISTENT"] = "PERSISTENT";
    MatlabTokenType["CLASSDEF"] = "CLASSDEF";
    // Complex number
    MatlabTokenType["IMAGINARY"] = "IMAGINARY";
    // Special
    MatlabTokenType["EOF"] = "EOF";
    MatlabTokenType["NEWLINE"] = "NEWLINE";
    MatlabTokenType["ELLIPSIS"] = "ELLIPSIS";
})(MatlabTokenType || (MatlabTokenType = {}));
// Error types
export class MatlabError extends Error {
    position;
    constructor(message, position) {
        super(message);
        this.name = "MatlabError";
        this.position = position;
    }
}
export class MatlabLexerError extends MatlabError {
    constructor(message, position) {
        super(message, position);
        this.name = "MatlabLexerError";
    }
}
export class MatlabParseError extends MatlabError {
    constructor(message, position) {
        super(message, position);
        this.name = "MatlabParseError";
    }
}
export class MatlabRuntimeError extends MatlabError {
    constructor(message, position) {
        super(message, position);
        this.name = "MatlabRuntimeError";
    }
}
//# sourceMappingURL=types.js.map